import * as Sentry from '@sentry/react'
import { beforeBreadcrumb, beforeSend } from 'src/service/utils/sentry'
import { SENTRY_DENY_URLS, SENTRY_IGNORE_ERRORS } from 'src/service/utils/sentry/filters'

export function initSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV ?? 'development',
    release: process.env.REACT_APP_VERSION,
    enabled: process.env.REACT_APP_ENV === 'production',
    // enabled: true,
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    denyUrls: SENTRY_DENY_URLS,

    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: false,
        fetch: false,
        dom: false,
        console: true,
      }),
    ],
    maxBreadcrumbs: 100,
    beforeSend: beforeSend,
    beforeBreadcrumb: beforeBreadcrumb,
  })
}
